import dynamic from 'next/dynamic'
import { TUSL2MobileBottomStickyProps } from './types'

const USL2MobileBottomSticky = dynamic(() => import('./mobile-bottom-sticky'))

export function USL2MobileBottomStickyLazy(
  props: TUSL2MobileBottomStickyProps,
) {
  return <USL2MobileBottomSticky {...props} />
}
